import { v4 as uuid } from "uuid";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type SubscriptionClientIdState = {
  subscriptionClientId: string;
};

type SubscriptionClientIdActions = Record<never, never>;

const initialState: SubscriptionClientIdState = {
  subscriptionClientId: uuid(),
};

export const createSubscriptionClientIdSlice: WaterlyAppStateCreator<
  SubscriptionClientIdActions,
  SubscriptionClientIdState
> = () => ({
  ...initialState,
});
